// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__PoY6Y","imageUploader":"EGiftCard_imageUploader__2b9g0"};